"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33569],{

/***/ 33569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73040);



var Description = function(param) {
    var title = param.title, icerik = param.icerik;
    var discover = (0,_context_TranslationContext__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .m)().discover;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full lg:mt-6 relative px-5 sm:px-[1.3rem] lg:px-0 bg-bg-Description-bg lg:bg-none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pt-12 lg:pl-8 flex flex-col pb-32 bg-bg-Description-bg before:content-[''] before:h-full before:bg-bg-Description-bg before:absolute before:w-full before:-left-full before:top-0 after:content-[''] after:h-full after:bg-bg-Description-bg after:absolute after:w-full after:-right-full after:top-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-medium text-13 tracking-5",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold text-[22px] -mt-1 lg:text-lg text-orange",
                    children: discover
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-sm opacity-75 mt-6 text-brand-black leading-[23px]",
                    dangerouslySetInnerHTML: {
                        __html: icerik
                    }
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Description);


/***/ })

}]);